import { render, staticRenderFns } from "./SessionPrices.vue?vue&type=template&id=533f45b4&"
import script from "./SessionPrices.vue?vue&type=script&lang=js&"
export * from "./SessionPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports